<template>
  <div id="app-index">
    <home-head></home-head>
    <home-nav></home-nav>
    <div class="login-box">
      <div class="login">
        <div class="login-top">
          <ul>
            <li class="active">用户登录</li>
          </ul>
        </div>
        <div>
          <div class="login-bottom">
            <div class="phone-box">
              <span>+86</span>
              <input
                type="text"
                placeholder="手机号码"
                onkeyup="this.value=this.value.replace(/[^\d]/g,'');"
                v-model.trim="userData.phone"
              />
            </div>
            <div class="input-box">
              <input
                type="text"
                placeholder="获取验证码"
                onkeyup="this.value=this.value.replace(/[^\d]/g,'');"
                v-model.trim="userData.code"
                @keyup.enter="userLogin"
              />
              <button :disabled="disabledCode" @click="sendSmsCode(userData)">{{codeText}}</button>
            </div>
          </div>
          <div class="btn-box">
            <button @click="userLogin">登录</button>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="login-foot">
      <div class="footer-box">
        <div class="f-top">
          <div class="top-l">
            <span>公益捐赠帐户名称 / 湖南爱眼公益基金会</span>
            <span>开户行 / 浦发银行长沙市生物医药支行</span>
            <span>账号 / 6618 0155 2000 00154</span>
          </div>
          <p>技术支持 / 普益云科技</p>
        </div>
        <div class="f-top">
          <div class="top-l">
            <span>联系电话 / 0731-85510451</span>
            <span>传真 / 0731-85510451</span>
            <span>电子邮件 / aiyanjijin@163.com</span>
            <span>湘公网安备 43010302000460号</span>
          </div>
          <p>网站备案号/湘ICP备15008901号-1</p>
        </div>
      </div>
    </div>-->
    <foot></foot>
  </div>
</template>
<script>
import animate from "animate.css";
import homeHead from "../Public/head";
import homeNav from "../Public/nav";
import foot from "../Public/foot";
export default {
  components: {
    homeHead,
    homeNav,
    foot
  },
  data() {
    return {
      userData: {},
      codeText: "获取验证码",
      disabledCode: false
    };
  },
  created() {
    if(sessionStorage.getItem('token')){
      this.$router.push({name:'homeIndex'})
     }
  },
  destroyed() {
    window.removeEventListener("scroll", this.isElementInViewport, true);
  },
  methods: {
    checkPhone(val) {
      let mobile = /^[1][0-9]{10}$/;
      if (!mobile.test(val)) {
        return false;
      } else {
        return true;
      }
    },
    checkUser() {
      //忘记密码发送验证码之前监测用户是否为单位工作人员
      if (!this.checkPhone(this.forgetData.phone)) {
        return this.$message.warning("请输入正确的手机号码！");
      } else {
        this.$db
          .post(this.$db.config.checkPhoneHas, { phone: this.forgetData.phone })
          .then(res => {
            if (res.code == 200 && res.data) {
              this.sendSmsCode(this.forgetData);
            }
          });
      }
    },
    sendSmsCode(data) {
      if (!this.checkPhone(data.phone)) {
        return this.$message.warning("请输入正确的手机号码！");
      } else {
        var second = 60;
        var self = this;
        // 定时器
        var codeLimit = setInterval(function() {
          self.disabledCode = true;
          second--;
          self.codeText = second + "秒";
          if (second == 0) {
            clearInterval(codeLimit);
            self.disabledCode = false;
            self.codeText = "发送验证码";
          }
        }, 1000);
        this.$db
          .post(this.$db.config.sendCodeUrl, { mobile: data.phone })
          .then(res => {
            if (res.code == 200) {
              return this.$message.success(res.msg);
            }
          });
      }
    },

    userLogin() {
      //用户登录
      if (!this.userData.phone || !this.userData.code) {
        return this.$message.warning("请填写登录信息！");
      } else {
        this.$db
          .post(this.$db.config.doUserLoginUrl, {
            phone: this.userData.phone,
            code: this.userData.code
          })
          .then(res => {
            if (res.code == 200) {
              sessionStorage.setItem("token", res.data["access-token"]);
              let backUrl = sessionStorage.getItem("backUrl");

              if (backUrl) {
                this.$router.push({ path: sessionStorage.getItem("backUrl") });
              } else {
                this.$router.push({
                  name: "index"
                });
              }
            }
          });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
#app-index {
  width: 100%;
}
.login-box {
  width: 100%;
  height: 655px;
  border-bottom: 1px solid #c30d23;
  background: url(../../assets/images/login_bg1.jpg) no-repeat;
  background-size: 100% 100%;
  position: relative;
  .login {
    width: 495px;
    min-height: 430px;
    background-color: #ffffff;
    box-shadow: 1px 1px 16px 0px rgba(11, 2, 5, 0.04);
    border-radius: 4px;
    border: solid 1px #ededed;
    position: absolute;
    top: 96px;
    right: 18%;
    .login-top {
      padding: 35px 63px 35px 63px;
      > ul {
        display: flex;
        justify-content: space-between;
        > li {
          list-style: none;
          padding-bottom: 6px;
          color: #999999;
          font-size: 20px;
          cursor: pointer;
          &.active {
            border-bottom: 2px solid #c30d23;
            color: #c30d23;
          }
        }
      }
    }
    .big-password {
      .btn-box {
        padding-top: 30px;
      }
    }
    .password-box {
      padding: 0 56px;
      .phone-box {
        border-bottom: 1px solid #ddd;
        justify-content: flex-start;
        margin-bottom: 26px;
        > input {
          margin: 0;
          padding: 0;
          outline: none;
          border: none;
          font-size: 18px;
          color: #333;
          width: 80%;
          padding: 8px 0;
          padding-left: 15px;
        }
        > span {
          color: #333333;
          font-size: 20px;
          padding-right: 16px;
          border-right: 1px solid #ddd;
          position: relative;
          top: 1px;
        }
      }

      .input-box {
        display: flex;
        border-bottom: 1px solid #ddd;
        justify-content: space-between;
        margin-bottom: 26px;
        > input {
          margin: 0;
          padding: 0;
          outline: none;
          border: none;
          font-size: 18px;
          color: #c0c0c0;
          width: 65%;
          padding: 8px 0;
          padding-left: 15px;
        }
        > button {
          margin: 0;
          padding: 0;
          outline: none;
          border: none;
          font-size: 20px;
          color: #4983bf;
          background-color: #fff;
          height: 38px;
          line-height: 38px;
          cursor: pointer;
        }
      }
    }
    .login-bottom {
      padding: 0 56px;
      .phone-box {
        border-bottom: 1px solid #ddd;
        justify-content: flex-start;
        margin-bottom: 50px;
        > input {
          margin: 0;
          padding: 0;
          outline: none;
          border: none;
          font-size: 18px;
          color: #333;
          width: 80%;
          padding: 8px 0;
          padding-left: 15px;
        }
        > span {
          color: #333333;
          font-size: 20px;
          padding-right: 16px;
          border-right: 1px solid #ddd;
          position: relative;
          top: 1px;
        }
      }

      .input-box {
        display: flex;
        border-bottom: 1px solid #ddd;
        justify-content: space-between;
        > input {
          margin: 0;
          padding: 0;
          outline: none;
          border: none;
          font-size: 18px;
          color: #c0c0c0;
          width: 70%;
          padding: 8px 0;
          // padding-left: 15px;
        }
        > button {
          margin: 0;
          padding: 0;
          outline: none;
          border: none;
          font-size: 20px;
          color: #4983bf;
          background-color: #fff;
          height: 38px;
          line-height: 38px;
          cursor: pointer;
        }
      }
    }
    .btn-box {
      padding: 54px;
      > button {
        margin: 0;
        padding: 0;
        outline: none;
        border: none;
        width: 100%;
        padding: 14px 0;
        text-align: center;
        font-size: 20px;
        color: #ffffff;
        box-shadow: 2px 3px 10px 0px rgba(9, 1, 4, 0.21);
        border-radius: 6px;
        background-color: #c30d23;
        cursor: pointer;
      }
    }
  }
}
.login-foot {
  width: 100%;
  margin-bottom: 50px;
  .footer-box {
    width: 1300px;
    margin: 0 auto;
    padding: 26px 0;
    .f-top {
      display: flex;
      justify-content: space-between;
      margin-bottom: 8px;
      &:last-child {
        margin-bottom: 0;
      }
      .top-l {
        > span {
          font-size: 14px;
          color: #707278;
          padding: 0 20px;
          border-right: 1px solid #707278;
          &:first-child {
            padding-left: 0;
          }
          &:last-child {
            border-right: none;
          }
        }
      }
      > p {
        font-size: 14px;
        color: #707278;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login/login_index.vue